var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8926 2.14258C6.51953 2.14258 2.14258 6.51953 2.14258 11.8926C2.14258 17.2656 6.51953 21.6426 11.8926 21.6426C17.2656 21.6426 21.6426 17.2656 21.6426 11.8926C21.6426 6.51953 17.2656 2.14258 11.8926 2.14258ZM11.8926 3.64258C16.457 3.64258 20.1426 7.32812 20.1426 11.8926C20.1426 16.457 16.457 20.1426 11.8926 20.1426C7.32812 20.1426 3.64258 16.457 3.64258 11.8926C3.64258 7.32812 7.32812 3.64258 11.8926 3.64258ZM8.89258 7.83203L7.83203 8.89258L8.36524 9.41992L10.832 11.8926L8.36524 14.3652L7.83203 14.8926L8.89258 15.9531L9.41992 15.4199L11.8926 12.9531L14.3652 15.4199L14.8926 15.9531L15.9531 14.8926L15.4199 14.3652L12.9531 11.8926L15.4199 9.41992L15.9531 8.89258L14.8926 7.83203L14.3652 8.36524L11.8926 10.832L9.41992 8.36524L8.89258 7.83203Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.05c66583110582008dad9e2c1bb5de5a.svg";
export { ForwardRef as ReactComponent };